/**
 * Add Postman buttons.
 */
(() => {
  const openApiElements = document.querySelectorAll("[data-openapi-url]");
  if (!openApiElements.length) {
    return;
  }

  // Fetch the postmanCollections.json file
  fetch("/assets/javascripts/postmanCollections.json")
    .then((response) => response.json())
    .then((postmanCollections) => {
      const currentPagePath = window.location.pathname;

      // Check if the current page path matches any key.
      for (const [path, collectionUid] of Object.entries(postmanCollections)) {
        if (currentPagePath.endsWith(path)) {
          openApiElements.forEach((elem) => {
            // Create the button element.
            const button = document.createElement("a");
            button.href = `https://app.getpostman.com/run-collection/${collectionUid}?action=collection%2Ffork&source=rip_markdown&collection-url=entityId%3D${collectionUid}%26entityType%3Dcollection%26workspaceId%3Ddbd55726-42a0-4b45-99c7-91cfe3dc34a2`;
            button.innerHTML = '<img src="/assets/images/postman-button.svg" alt="Run in Postman">';

            // Insert the button before the OpenAPI spec.

            elem.parentNode.insertBefore(button, elem);
          });
          break;
        }
      }
    })
    .catch((error) => console.error("Error fetching the postman collections:", error));
})();
